import { defineStore } from 'pinia';

export const useLocationStore = defineStore('location',{
    state: () => ({
        locations: [] as LocationData[],
        lastApiCall: 0 as number,
        
      }),
      actions: {
        async getLocations(data:string): Promise<LocationData[]> {
          const { $axios } = useNuxtApp();
          const geocodingApiKey = useRuntimeConfig().public.geocodingApiKey;
          const geocodingApiUrl = useRuntimeConfig().public.geocodingApiUrl;
          if(Date.now() - this.lastApiCall > 500) {
            this.lastApiCall = Date.now();
            try {
              let response = await $axios.get(`${geocodingApiUrl}search?text=${data}&apiKey=${geocodingApiKey}&limit=10`);
            this.locations = response.data.features.map((feature: any) => {
              return {
                place_id: feature.properties.place_id,
                name: feature.properties.name || feature.properties.formatted,
                display_name: feature.properties.formatted,
                lat: feature.properties.lat,
                lon: feature.properties.lon
              } as LocationData;
            });
            } catch (error) {
              this.locations = [];
            }
            return this.locations;
          } else {
            return [];
          }
          
        },
        async getAddr(lat: number, lon: number): Promise<string> {
          const { $axios } = useNuxtApp();
          const geocodingApiKey = useRuntimeConfig().public.geocodingApiKey;
          const geocodingApiUrl = useRuntimeConfig().public.geocodingApiUrl;
          if(Date.now() - this.lastApiCall > 500) {
            this.lastApiCall = Date.now();
            try {
              let response = await $axios.get(`${geocodingApiUrl}reverse?lat=${lat}&lon=${lon}&apiKey=${geocodingApiKey}`);
              return response.data.features[0].properties.formatted as string;
            } catch(error) {
              return "";
            }
            
          } else{
            return "";
          }
          
        }
      },
})